import { Navigate, useLocation } from "react-router-dom";
import { buildHostFallbackPath } from "@/lib/buildHostFallbackPath";

// Build-host catch-all (2026-10 staging fix). "/build/..." paths have no route on the Build host,
// so they land here. The old catch-all navigated straight to /login and won the race against
// BuildHostRewrite's effect, so the Google callback's "/build/me" landing always ended on /login
// even with a valid session. Non-/build unknown paths still go to /login.
export function BuildHostFallback() {
  const loc = useLocation();
  return <Navigate to={buildHostFallbackPath(loc.pathname, loc.search, loc.hash)} replace />;
}
